import React, { useEffect, useRef, useState } from "react";

import { catalogSearchUrl } from "../../lib/storefront";
import { CloseIcon, SearchIcon } from "./icons";

const IS_MAC = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || "");

/**
 * The storefront's catalog search ("Khilaf apa hari ini?"), as a plain form.
 *
 * It leaves this app: submitting goes to hanamaru's /search with the same
 * parameters its navbar builds. hanamaru's typeahead (search.kyou.id) and
 * recent-items panel are not ported -- the box searches the catalog, and the
 * help-center search lives in the page itself. Keeping the two visibly apart
 * is the point of the handover's "two searches" note.
 */
export const DesktopCatalogSearch = React.forwardRef((props, ref) => {
  const [query, setQuery] = useState("");

  const submit = e => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed !== "") window.location.assign(catalogSearchUrl(trimmed));
  };

  return (
    <form className="site-search" onSubmit={submit} role="search">
      <input
        ref={ref}
        type="text"
        name="search"
        className="site-search__input"
        placeholder="Khilaf apa hari ini?"
        aria-label="Cari produk di Kyou.id"
        value={query}
        onChange={e => setQuery(e.target.value)}
        autoComplete="off"
      />
      {query.length === 0 ? <kbd className="site-search__kbd">{IS_MAC ? "⌘K" : "Ctrl K"}</kbd> : null}
      <button type="submit" className="site-search__submit" aria-label="Cari produk">
        <SearchIcon className="site-search__submit-icon" />
      </button>
    </form>
  );
});

/** Full-screen catalog search for phones, opened from the navbar's search icon. */
export const MobileCatalogSearch = ({ open, onClose }) => {
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    if (inputRef.current) inputRef.current.focus();
    const closeOnEscape = e => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open, onClose]);

  if (!open) return null;

  const submit = e => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed !== "") window.location.assign(catalogSearchUrl(trimmed));
  };

  return (
    <div className="site-search-sheet" role="dialog" aria-modal="true" aria-label="Cari produk">
      <form className="site-search-sheet__bar" onSubmit={submit} role="search">
        <button type="button" className="site-icon-btn" onClick={onClose} aria-label="Tutup pencarian">
          <CloseIcon />
        </button>
        <input
          ref={inputRef}
          type="text"
          className="site-search-sheet__input"
          placeholder="Khilaf apa hari ini?"
          aria-label="Cari produk di Kyou.id"
          value={query}
          onChange={e => setQuery(e.target.value)}
          autoComplete="off"
        />
        <button type="submit" className="site-search__submit" aria-label="Cari produk">
          <SearchIcon className="site-search__submit-icon" />
        </button>
      </form>
    </div>
  );
};
